import { P2GBox, P2GText } from '@parcel2go/core-ui';
import { CurrentSelectionType } from '../utils/CurrentSelectionType';
import { GetColumnHeading } from '../utils/GetColumnHeading';
import { ServiceSpeedType } from '../utils/PopulateQuoteTags';

interface props {
  currentSelection: CurrentSelectionType;
  serviceType: ServiceSpeedType;
  index: number;
}

export const QuoteLayoutColumnHeader: React.FC<props> = (props) => {
  return (
    <P2GBox
      className={`p2g-quote-columnheader p2g-quote-columnheader-${props.index}`}
      sx={(t) => ({
        color: '#fff',
        backgroundColor: t.palette.primary.dark,
        textAlign: 'center',
        padding: t.spacing(1),
        marginBottom: t.spacing(2)
      })}
    >
      <P2GText colour="inherit" component="span" variant="h6">
        {GetColumnHeading(
          props.serviceType,
          props.currentSelection.provider,
          props.currentSelection?.recipient?.CountryIsoCode,
          props.currentSelection?.sender?.CountryIsoCode
        )}
      </P2GText>
    </P2GBox>
  );
};
